import script from "./searchTop.vue?vue&type=script&setup=true&lang=js"
export * from "./searchTop.vue?vue&type=script&setup=true&lang=js"

import "./searchTop.vue?vue&type=style&index=0&id=3826250a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3826250a"]])

export default __exports__